import { render, staticRenderFns } from "./RiwayatPelayananDetail.vue?vue&type=template&id=587cb6c3&scoped=true"
import script from "./RiwayatPelayananDetail.vue?vue&type=script&lang=js"
export * from "./RiwayatPelayananDetail.vue?vue&type=script&lang=js"
import style0 from "./RiwayatPelayananDetail.vue?vue&type=style&index=0&id=587cb6c3&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587cb6c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587cb6c3')) {
      api.createRecord('587cb6c3', component.options)
    } else {
      api.reload('587cb6c3', component.options)
    }
    module.hot.accept("./RiwayatPelayananDetail.vue?vue&type=template&id=587cb6c3&scoped=true", function () {
      api.rerender('587cb6c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/riwayat_pasien/RiwayatPelayananDetail.vue"
export default component.exports